<!--<div id="sidebar_main" uk-sticky="end: .sidebar_main_swipe;" [attr.offset]="offset" class="uk-visible@m">-->
<div id="sidebar_main" [attr.offset]="offset" class="uk-visible@m" style="position: fixed; top: var(--header-height) !important; z-index: 980; height: 100%;">
  <div sidebar-content [collapsible]="collapsible">
    <ng-container *ngTemplateOutlet="menu; context: {mobile: false}"></ng-container>
  </div>
</div>
<div class="uk-hidden@m">
  <div id="sidebar_offcanvas" #sidebar_offcanvas [attr.uk-offcanvas]="'overlay: true'">
    <div class="uk-offcanvas-bar uk-padding-remove">
      <nav class="uk-navbar uk-background-default" uk-sticky>
        <div class="uk-navbar-right">
          <button class="uk-navbar-toggle uk-icon uk-close" (click)="closeOffcanvas()">
            <icon name="close" [ratio]="1.5" visuallyHidden="close menu"></icon>
          </button>
        </div>
      </nav>
      <ng-container *ngTemplateOutlet="menu; context: {mobile: true}"></ng-container>
    </div>
  </div>
</div>

<ng-template #menu let-mobile=mobile>
  <!--  By default the back class is used class="back" -->
  @if (backItem) {
    <div class="" [class.mobile]="mobile" [ngClass]="backItem.customClass">
      <a [routerLink]="backItem.route" [queryParams]="backItem.params" class="uk-flex uk-flex-middle uk-flex-center"
        (click)="closeOffcanvas()" [queryParamsHandling]="queryParamsHandling">
        @if (backItem.icon) {
          <div class="uk-width-auto uk-margin-right">
            <icon [name]="backItem.icon.name" [ratio]="1.3" [svg]="backItem.icon.svg" [flex]="true"></icon>
          </div>
        }
        <span class="uk-width-expand uk-text-truncate uk-flex uk-flex-center" [class.hide-on-close]="backItem.icon">
          {{backItem.title}}
        </span>
      </a>
    </div>
  }
  <ng-container *ngTemplateOutlet="logoTpl"></ng-container>
  <!--  <div *ngIf="logoURL" id="sidebar_logo" class="uk-margin-top">-->
  <!--    <img [src]="logoURL" alt="Logo">-->
<!--  </div>-->
@for (section of menuSections; track section) {
  <div class="menu_section uk-margin-medium-top" [class.mobile]="mobile" [ngClass]="section.customClass">
    <ul #nav class="uk-list uk-nav" [class.uk-list-large]="mobile" [class.uk-nav-default]="!mobile"
      [class.uk-nav-primary]="mobile" uk-nav="duration: 400">
      @for (item of section.items; track item) {
        <!--  Apply uk-parent so subItems collapse when selecting an item with no subItems / Remove uk-parent for external links  -->
        <li [class.uk-active]="item.isActive" [ngClass]="item.customClass" [class.uk-parent]="!(item.url && !item.route)">
          @if (item.url && !item.route) {
            <a
              [title]="item.title" (click)="item.items.length === 0?closeOffcanvas():null"
              [href]="item.url" [target]="item.target" class="uk-flex uk-flex-middle">
              @if (item.icon && (item.icon.svg || item.icon.name)) {
                <div class="uk-width-auto">
                  <icon class="menu-icon" [customClass]="item.icon.class" [name]="item.icon.name" [ratio]="item.icon.ratio?item.icon.ratio:0.9" [svg]="item.icon.svg" [flex]="true"></icon>
                </div>
              }
              <span [class.hide-on-close]="item.icon" class="uk-width-expand@l uk-text-truncate uk-margin-small-left">
                {{item.title}}
              </span>
              @if (item.items.length > 0) {
                <span class="uk-nav-parent-icon hide-on-close"></span>
              }
            </a>
          } @else {
            <a [routerLink]="getItemRoute(item)"
              [queryParams]="item.route?item.params:null" [queryParamsHandling]="item.route?queryParamsHandling:null"
              [title]="item.title" (click)="item.items.length === 0?closeOffcanvas():null"
              [href]="item.url ?? null" [target]="item.url ? item.target : null" class="uk-flex uk-flex-middle">
              @if (item.icon && (item.icon.svg || item.icon.name)) {
                <div class="uk-width-auto">
                  <icon class="menu-icon" [customClass]="item.icon.class" [name]="item.icon.name" [ratio]="item.icon.ratio?item.icon.ratio:0.9" [svg]="item.icon.svg" [flex]="true"></icon>
                </div>
              }
              <span [class.hide-on-close]="item.icon" class="uk-width-expand@l uk-text-truncate uk-margin-small-left">
                {{item.title}}
              </span>
              @if (item.items.length > 0) {
                <span class="uk-nav-parent-icon hide-on-close"></span>
              }
            </a>
          }
          @if (item.items?.length > 0 && (isBrowser || item.isActive)) {
            <ul class="uk-nav-sub">
              @for (subItem of item.items; track subItem) {
                <li [ngClass]="subItem.customClass" [class.uk-active]="subItem.isActive">
                  <a [routerLink]="subItem.route?subItem.route:null" [title]="subItem.title" (click)="closeOffcanvas()"
                    [queryParams]="subItem.route?subItem.params:null" [queryParamsHandling]="subItem.route?queryParamsHandling:null">
                    <span class="uk-text-truncate">{{subItem.title}}</span>
                  </a>
                </li>
              }
            </ul>
          }
        </li>
      }
    </ul>
  </div>
}

<ng-container *ngTemplateOutlet="footerTpl"></ng-container>

</ng-template>
